import type { SVGProps } from 'react';

const SvgPickerArrowUpFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.2929 8.70711C11.6834 8.31658 12.3166 8.31658 12.7071 8.70711L18.2929 14.2929C18.9229 14.9229 18.4767 16 17.5858 16H6.41421C5.52331 16 5.07714 14.9229 5.70711 14.2929L11.2929 8.70711Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgPickerArrowUpFilled;
